<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-newspaper"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="newsDetail.name"
                    filled
                    label="Name"
                    placeholder="Enter news name"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="newsDetail.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập slug"
                    @blur="getSeo"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="newsDetail.short_description"
                    filled
                    label="Short description"
                    placeholder="Enter short description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Description</div>
                <ck-content :content="newsDetail.description" class="ck-project"
                            @blur="getSeo" @getData="value => newsDetail.description = value"></ck-content>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="newsDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên bài viết"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="newsDetail.short_description_vi"
                    filled
                    label="Mô tả ngắn"
                    placeholder="Nhập mô tả"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Mô tả</div>
                <ck-content :content="newsDetail.description_vi" class="ck-project"
                            @blur="getSeo" @getData="value => newsDetail.description_vi = value"></ck-content>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-text-field
                v-model="newsDetail.seo_name"
                filled
                label="SEO Title"
                placeholder="Nhập SEO Title"
                @blur="getSeo"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="newsDetail.seo_description"
                filled
                label="SEO Description"
                placeholder="Nhập SEO Description"
                @blur="getSeo"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="newsDetail.seo_key"
                filled
                label="SEO Keyword"
                placeholder="Nhập SEO Keyword"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                v-model="image"
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change="uploadImg"
            ></v-file-input>
            <v-img :class="[display_image ? 'mb-8':'d-none']"
                   :src="display_image? display_image :''" aspect-ratio="1.7"
                   contain
            ></v-img>
          </v-col>
        </v-col>
        <v-col class="white rounded-lg mt-3" cols="12">
          <v-row class="mx-3">
            <h4 class="my-5">Hỗ trợ SEO</h4>
            <v-col cols="12">
              <v-text-field
                  v-model="text_seo"
                  counter="200"
                  label="Focus Keyword"
                  type="text"
                  @blur="getSeo"
              ></v-text-field>
            </v-col>
            <v-col
                class="rounded-lg mb-5"
                cols="12"
                style="border: 1px solid #dadada"
            >
              <div class="d-flex ">
                <h5 class="pt-2 mr-3">Basic SEO</h5>
                <div
                    class="rounded-xl white--text text-center"
                    style="
                    background: #f39d96;
                    width: 100px;
                    height: 35px;
                    line-height: 32px;
                  "
                >
                  <v-icon color="white">mdi-close</v-icon>
                  {{ errors_ }}
                </div>
              </div>
              <div v-for="(item, index) in SEO" v-bind:key="index" class="mt-3">
                <v-icon
                    class="mr-2"
                    color="white"
                    size="20"
                    style="background: #f39d96; border-radius: 50%"
                >mdi-close
                </v-icon
                >
                {{ item.title }}
                <v-icon color="#B6BFC9">help</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="text-center" cols="12">
          <v-btn color="primary" width="180" @click="save()"> Lưu</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CkContent from "@/components/ck-content";
import {GET_DETAIL_NEWS, UPDATE_NEWS} from "@/store/modules/news";
import {GET_LIST_SEO} from "@/store/modules/seo";
import {mapGetters} from "vuex";
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import validateSlug from "@/mixins/validateSlug";


export default {
  name: "Edit_news",
  mixins: [validateSlug],
  components: {
    CkContent
  },
  data() {
    return {
      page: "Sửa tin tức",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tin tức",
          disabled: true,
        },
        {
          text: "Sửa tin tức",
          disabled: false,
        },
      ],
      url: '',
      //uploadImg
      image: null,
      display_image: '',
      //SEO
      text_seo: "",
      errors_: 0,
      SEO: [],
      seo_name: ''
      , seo_description: ''
      , seo_key: ''
    }
  },
  computed: {
    ...mapGetters({
      newsDetail: "newsDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_NEWS, this.$route.params.id);
  },
  watch: {
    newsDetail(val) {
      if (val && val.photo_url) {
        this.display_image = this.url + val.photo_url;

      }
    },
  },
  methods: {
    onKeyUp(value) {
      this.newsDetail.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImg(e) {
      if (!e) {
        this.display_image = "";
        this.newsDetail.photo_url = "";
      }
      this.display_image = URL.createObjectURL(e)
      this.$forceUpdate()
    },

    getSeo() {
      let formData = new FormData();
      formData.append("keyword", this.text_seo);
      formData.append("title", this.newsDetail.seo_name);
      formData.append("data_content", this.newsDetail.description);
      formData.append("slug", this.newsDetail.slug);
      formData.append("meta_description", this.newsDetail.seo_description);
      this.$store.dispatch(`${GET_LIST_SEO}`, formData).then((data) => {
        if (data.data.status == 0) {
          this.SEO = [];
          data.data.errors.forEach((element) => {
            let data = {
              title: element,
            };
            this.SEO.push(data);
          });
          this.errors_ = this.SEO.length
        } else {
          // alert(data.data.errors)
        }
      });
    },
    async save() {
      if (this.image != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.image);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.newsDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      await this.$store.dispatch(`${UPDATE_NEWS}`, this.newsDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/news')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>